<template>
  <div
    v-lazy:background-image="{
      src: (item.himg || item.small_img) + smallImgRule,
      error: errorimage,
      loading: loadimage
    }" class="common_two_col_box">
    <div v-show="item.pay_type === 1" class="common_two_col_icon" />
    <div class="dialog_box">
      <div class="dialog_item_topLeft"><slot name="topLeft" /></div>
      <div class="dialog_item_topRight"><slot name="topRight" /></div>
      <div class="dialog_item_center"><slot name="center" /></div>
    </div>
  </div>
</template>

<script>
const loadimage = require('@/assets/images/bg_loading.png')
const errorimage = require('@/assets/images/bg_loading_error.png')

export default {
  name: 'TwoColItem',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      // 不支持webp
      smallImgRule: '?x-oss-process=image/resize,w_216,h_247,m_lfit/quality,q_80/interlace,1',
      loadimage,
      errorimage,
    }
  }
}
</script>

<style lang="scss" scoped>
.common_two_col_box {
  position: relative;
  display: inline-block;
  width: 190px;
  height: 107px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 4px;
  box-shadow: $box_shadow_2;

  &:hover { .dialog_box { display: block; } }

  &.common_two_col_box[lazy=loading], &.common_two_col_box[lazy=error] { background-position: center center; background-size: 40px 26px; }

  .common_two_col_icon { width: 18px; height: 23px; margin-left: 8px; background-image: url(~@/assets/images/icon_vip.png); background-size: cover; }

  .dialog_box {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: none;
    background-color: $dialog_color_5;

    .dialog_item_topLeft { position: absolute; top: 6px; left: 6px; }
    .dialog_item_topRight { position: absolute; top: 6px; right: 6px; }
    .dialog_item_center { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); }
  }
}
</style>
